import React from 'react';
import Input from '../../../../components/ui/Input';

const VerificationInputs = ({ otp, onChange, onKeyDown, error, disabled }) => {
  return (
    <div className="space-y-4">
      <label className="block text-sm font-medium text-accent-700 text-center">
        Enter Verification Code
      </label>

      <div className="flex justify-center space-x-3">
        {otp.map((digit, index) => (
          <Input
            key={index}
            id={`otp-${index}`}
            type="text"
            value={digit}
            onChange={(e) => onChange(index, e.target.value)}
            onKeyDown={(e) => onKeyDown(index, e)}
            className={`w-12 h-12 text-center text-xl font-semibold rounded-lg border-2 transition-all duration-200 ${error
                ? 'border-error focus:border-error focus:ring-error'
                : digit
                  ? 'border-success bg-success-50 focus:border-success focus:ring-success' : 'border-accent-200 focus:border-primary focus:ring-primary'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            maxLength={1}
            disabled={disabled}
            autoComplete="off"
            inputMode="numeric"
            pattern="[0-9]*"
          />
        ))}
      </div>

      <div className="text-center">
        <p className="text-xs text-accent-500">
          Enter the 6-digit code sent to your email
        </p>
      </div>
    </div>
  );
};

export default VerificationInputs;